/**
 * The Empire drawer: the roster (Units | Buildings | Workers, and the idle
 * workers button) behind a tab that opens and closes it (key E,
 * `ui.empireOpen`), so the map behind it is free when the roster isn't needed.
 */
import type { ReactNode } from 'react';
import { NO_HIGHLIGHT, type UiStore, useUi } from '../ui/store';

export function EmpireDrawer({ ui, children }: { ui: UiStore; children: ReactNode }) {
  const open = useUi(ui, (s) => s.empireOpen);
  const toggle = (
    <button
      type="button"
      aria-expanded={open}
      title={
        open ? 'Hide the Empire list (E)' : 'Show the Empire list: units, buildings, workers (E)'
      }
      onClick={() => ui.set(toggleEmpire)}
      className="pill pointer-events-auto flex h-7 shrink-0 items-center gap-1.5 self-start px-3 text-xs transition hover:bg-fill-hover"
    >
      <span aria-hidden="true">{open ? '‹' : '›'}</span>
      Empire
      <kbd className="text-fg-subtle">E</kbd>
    </button>
  );
  if (!open) return toggle;
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2">
      {toggle}
      {children}
    </div>
  );
}

/** Opens or closes the drawer; closing clears what a hovered roster row pointed at (it unmounts before its mouseleave). */
export function toggleEmpire(s: { empireOpen: boolean }) {
  return s.empireOpen ? { empireOpen: false, highlightIds: NO_HIGHLIGHT } : { empireOpen: true };
}
